// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: nTemu9zEsYx
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  hasVariant,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import Sidebar from "../../Sidebar"; // plasmic-import: KsLZ7sb8Ji8/component
import SearchRectangle from "../../SearchRectangle"; // plasmic-import: xSJM4Lfdlu/component
import MenuSelectStack from "../../MenuSelectStack"; // plasmic-import: hMQM8FKJ7E/component
import LoginInput from "../../LoginInput"; // plasmic-import: aQnFozGxZ1/component
import MilestoneEntry from "../../MilestoneEntry"; // plasmic-import: q-XYruS53k/component
import AdvancedOptionsComponent from "../../AdvancedOptionsComponent"; // plasmic-import: FhZFNoyzlv/component
import Switch from "../../Switch"; // plasmic-import: gp-QRljuykd/component
import AutomationSelect from "../../AutomationSelect"; // plasmic-import: F7BYn5PzZSi/component
import { useScreenVariants as useScreenVariantsnoO6HAIuEe } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: NoO6H-AIuEE/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicEscrowSubmission.module.css"; // plasmic-import: nTemu9zEsYx/css

createPlasmicElementProxy;

export const PlasmicEscrowSubmission__VariantProps = new Array();

export const PlasmicEscrowSubmission__ArgProps = new Array(
  "contractUploadText",
  "companySelected",
  "emailSelected"
);

const $$ = {};

function PlasmicEscrowSubmission__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "achSwitch.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => "isChecked"
      },
      {
        path: "cardSwitch.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => "isChecked"
      },
      {
        path: "cardSurchargeSwitch.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => "isChecked"
      },
      {
        path: "paymentReminderSwitch.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "paymentReminderSelect.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsnoO6HAIuEe()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <Sidebar
            data-plasmic-name={"sidebar"}
            data-plasmic-override={overrides.sidebar}
            className={classNames("__wab_instance", sty.sidebar)}
          />

          <div className={classNames(projectcss.all, sty.freeBox__tvf7S)}>
            <div className={classNames(projectcss.all, sty.freeBox__uHq6)}>
              <div
                data-plasmic-name={"sheet2"}
                data-plasmic-override={overrides.sheet2}
                className={classNames(projectcss.all, sty.sheet2)}
              >
                <p.Stack
                  as={"div"}
                  data-plasmic-name={"figmaPaste"}
                  data-plasmic-override={overrides.figmaPaste}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.figmaPaste)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__lSzho)}
                  >
                    <div
                      data-plasmic-name={"title4"}
                      data-plasmic-override={overrides.title4}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title4
                      )}
                    >
                      {"Contract Details"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"title3"}
                    data-plasmic-override={overrides.title3}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title3
                    )}
                  >
                    {"Client"}
                  </div>
                  <div
                    data-plasmic-name={"selectedClient"}
                    data-plasmic-override={overrides.selectedClient}
                    className={classNames(projectcss.all, sty.selectedClient)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__gD0Nn)}
                    >
                      {p.renderPlasmicSlot({
                        defaultContents: (
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text___4E2TB
                            )}
                          >
                            <React.Fragment>
                              <span
                                className={
                                  "plasmic_default__all plasmic_default__span"
                                }
                                style={{ fontWeight: 700 }}
                              >
                                {"Company"}
                              </span>
                            </React.Fragment>
                          </div>
                        ),

                        value: args.companySelected,
                        className: classNames(sty.slotTargetCompanySelected)
                      })}
                      <div
                        data-plasmic-name={"emailSelected"}
                        data-plasmic-override={overrides.emailSelected}
                        className={classNames(
                          projectcss.all,
                          sty.emailSelected
                        )}
                      >
                        {p.renderPlasmicSlot({
                          defaultContents: "email address",
                          value: args.emailSelected,
                          className: classNames(sty.slotTargetEmailSelected)
                        })}
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"deleteSelection"}
                      data-plasmic-override={overrides.deleteSelection}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.deleteSelection
                      )}
                    >
                      {"X"}
                    </div>
                  </div>
                  <SearchRectangle
                    data-plasmic-name={"searchRectangle"}
                    data-plasmic-override={overrides.searchRectangle}
                    className={classNames(
                      "__wab_instance",
                      sty.searchRectangle
                    )}
                  />

                  <MenuSelectStack
                    data-plasmic-name={"menuSelectStack"}
                    data-plasmic-override={overrides.menuSelectStack}
                    className={classNames(
                      "__wab_instance",
                      sty.menuSelectStack
                    )}
                  />

                  <div
                    data-plasmic-name={"title2"}
                    data-plasmic-override={overrides.title2}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title2
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "small")
                      ? "Contract Title"
                      : "Contract Title"}
                  </div>
                  <div
                    data-plasmic-name={"rectangle9"}
                    data-plasmic-override={overrides.rectangle9}
                    className={classNames(projectcss.all, sty.rectangle9)}
                  >
                    <LoginInput
                      data-plasmic-name={"contractTitleInput"}
                      data-plasmic-override={overrides.contractTitleInput}
                      className={classNames(
                        "__wab_instance",
                        sty.contractTitleInput
                      )}
                    />
                  </div>
                </p.Stack>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__u8PC)}>
                <div className={classNames(projectcss.all, sty.freeBox__g4Rm9)}>
                  <div
                    data-plasmic-name={"title10"}
                    data-plasmic-override={overrides.title10}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title10
                    )}
                  >
                    {"Milestones"}
                  </div>
                </div>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__x9TJb
                  )}
                >
                  {
                    "Let your client pay in installments as each step in the contract is completed."
                  }
                </div>
                <div
                  data-plasmic-name={"moreMilestonesStack"}
                  data-plasmic-override={overrides.moreMilestonesStack}
                  className={classNames(
                    projectcss.all,
                    sty.moreMilestonesStack
                  )}
                >
                  <MilestoneEntry
                    data-plasmic-name={"milestoneEntry"}
                    data-plasmic-override={overrides.milestoneEntry}
                    className={classNames("__wab_instance", sty.milestoneEntry)}
                    number={
                      hasVariant(globalVariants, "screen", "medium")
                        ? "1."
                        : "1."
                    }
                  />
                </div>
                <button
                  data-plasmic-name={"addMilestoneButton"}
                  data-plasmic-override={overrides.addMilestoneButton}
                  className={classNames(
                    projectcss.all,
                    projectcss.button,
                    projectcss.__wab_text,
                    sty.addMilestoneButton
                  )}
                  ref={ref => {
                    $refs["addMilestoneButton"] = ref;
                  }}
                >
                  {"+ Add Milestone"}
                </button>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox___6RkTi)}>
                <div className={classNames(projectcss.all, sty.freeBox__hy5BH)}>
                  <div
                    data-plasmic-name={"title11"}
                    data-plasmic-override={overrides.title11}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title11
                    )}
                  >
                    {"Contract Terms (optional)"}
                  </div>
                </div>
                <div
                  data-plasmic-name={"title12"}
                  data-plasmic-override={overrides.title12}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.title12
                  )}
                >
                  {
                    "Specify the terms of your contract and deliverables, while providing transparent proof-of-agreement in the event of a dispute arbitration. "
                  }
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__pXzkh)}>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__dxspa)}
                  >
                    <div
                      data-plasmic-name={"title17"}
                      data-plasmic-override={overrides.title17}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title17
                      )}
                    >
                      {"Upload signed contract or agreement (recommended)"}
                    </div>
                    <div
                      data-plasmic-name={"uploadButton"}
                      data-plasmic-override={overrides.uploadButton}
                      className={classNames(projectcss.all, sty.uploadButton)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__egVpj
                        )}
                      >
                        {hasVariant(globalVariants, "screen", "medium")
                          ? "Upload"
                          : "Upload"}
                      </div>
                    </div>
                    <div
                      className={classNames(projectcss.all, sty.freeBox__uya65)}
                    >
                      {p.renderPlasmicSlot({
                        defaultContents: (
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text___3Mrqa
                            )}
                          >
                            {"Enter some text"}
                          </div>
                        ),

                        value: args.contractUploadText,
                        className: classNames(sty.slotTargetContractUploadText)
                      })}
                    </div>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox___5AhiK)}
                  >
                    <div
                      data-plasmic-name={"title5"}
                      data-plasmic-override={overrides.title5}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title5
                      )}
                    >
                      {"OR"}
                    </div>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox___5Jpnn)}
                  >
                    <div
                      data-plasmic-name={"title19"}
                      data-plasmic-override={overrides.title19}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title19
                      )}
                    >
                      {
                        "Provide a description of the service or product that you are delivering"
                      }
                    </div>
                    <div
                      data-plasmic-name={"rectangle26"}
                      data-plasmic-override={overrides.rectangle26}
                      className={classNames(projectcss.all, sty.rectangle26)}
                    >
                      <textarea
                        data-plasmic-name={"contractDescription"}
                        data-plasmic-override={overrides.contractDescription}
                        className={classNames(
                          projectcss.all,
                          projectcss.textarea,
                          sty.contractDescription
                        )}
                        placeholder={
                          hasVariant(globalVariants, "screen", "medium")
                            ? ""
                            : undefined
                        }
                        ref={ref => {
                          $refs["contractDescription"] = ref;
                        }}
                        value={""}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__uBrfG)}>
                <AdvancedOptionsComponent
                  data-plasmic-name={"advancedOptionsInstance"}
                  data-plasmic-override={overrides.advancedOptionsInstance}
                  className={classNames(
                    "__wab_instance",
                    sty.advancedOptionsInstance
                  )}
                />

                <div
                  data-plasmic-name={"advancedOptionsStack"}
                  data-plasmic-override={overrides.advancedOptionsStack}
                  className={classNames(
                    projectcss.all,
                    sty.advancedOptionsStack
                  )}
                >
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.freeBox___58Nl)}
                  >
                    <div
                      data-plasmic-name={"title26"}
                      data-plasmic-override={overrides.title26}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title26
                      )}
                    >
                      {"Payment Methods"}
                    </div>
                    <Switch
                      data-plasmic-name={"achSwitch"}
                      data-plasmic-override={overrides.achSwitch}
                      className={classNames("__wab_instance", sty.achSwitch)}
                      isChecked={
                        p.generateStateValueProp($state, [
                          "achSwitch",
                          "isChecked"
                        ]) ?? false
                      }
                      onChange={(...eventArgs) => {
                        p.generateStateOnChangeProp($state, [
                          "achSwitch",
                          "isChecked"
                        ])(eventArgs[0]);
                      }}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__ec5AZ
                        )}
                      >
                        {"ACH"}
                      </div>
                    </Switch>
                    <Switch
                      data-plasmic-name={"cardSwitch"}
                      data-plasmic-override={overrides.cardSwitch}
                      className={classNames("__wab_instance", sty.cardSwitch)}
                      isChecked={
                        p.generateStateValueProp($state, [
                          "cardSwitch",
                          "isChecked"
                        ]) ?? false
                      }
                      onChange={(...eventArgs) => {
                        p.generateStateOnChangeProp($state, [
                          "cardSwitch",
                          "isChecked"
                        ])(eventArgs[0]);
                      }}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text___04O2W
                        )}
                      >
                        {"Card"}
                      </div>
                    </Switch>
                    <Switch
                      data-plasmic-name={"cardSurchargeSwitch"}
                      data-plasmic-override={overrides.cardSurchargeSwitch}
                      className={classNames(
                        "__wab_instance",
                        sty.cardSurchargeSwitch
                      )}
                      isChecked={
                        p.generateStateValueProp($state, [
                          "cardSurchargeSwitch",
                          "isChecked"
                        ]) ?? false
                      }
                      onChange={(...eventArgs) => {
                        p.generateStateOnChangeProp($state, [
                          "cardSurchargeSwitch",
                          "isChecked"
                        ])(eventArgs[0]);
                      }}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__qriIa
                        )}
                      >
                        {"Card (pass fee to client)"}
                      </div>
                    </Switch>
                  </p.Stack>
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.freeBox__nxtZl)}
                  >
                    <div
                      data-plasmic-name={"title27"}
                      data-plasmic-override={overrides.title27}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title27
                      )}
                    >
                      {hasVariant(globalVariants, "screen", "medium")
                        ? "Payment Reminders"
                        : "Payment Reminders"}
                    </div>
                    <Switch
                      data-plasmic-name={"paymentReminderSwitch"}
                      data-plasmic-override={overrides.paymentReminderSwitch}
                      className={classNames(
                        "__wab_instance",
                        sty.paymentReminderSwitch
                      )}
                      isChecked={
                        p.generateStateValueProp($state, [
                          "paymentReminderSwitch",
                          "isChecked"
                        ]) ?? false
                      }
                      onChange={(...eventArgs) => {
                        p.generateStateOnChangeProp($state, [
                          "paymentReminderSwitch",
                          "isChecked"
                        ])(eventArgs[0]);
                      }}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__vxrEe
                        )}
                      >
                        {"Payment Reminder Notifications"}
                      </div>
                    </Switch>
                    <div
                      data-plasmic-name={"paymentReminderStack"}
                      data-plasmic-override={overrides.paymentReminderStack}
                      className={classNames(
                        projectcss.all,
                        sty.paymentReminderStack
                      )}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__tNvOf
                        )}
                      >
                        {"Every:"}
                      </div>
                      <input
                        data-plasmic-name={"reminderNumber"}
                        data-plasmic-override={overrides.reminderNumber}
                        className={classNames(
                          projectcss.all,
                          projectcss.input,
                          sty.reminderNumber
                        )}
                        placeholder={"0"}
                        ref={ref => {
                          $refs["reminderNumber"] = ref;
                        }}
                        size={1}
                        type={"number"}
                        value={""}
                      />

                      <AutomationSelect
                        data-plasmic-name={"paymentReminderSelect"}
                        data-plasmic-override={overrides.paymentReminderSelect}
                        className={classNames(
                          "__wab_instance",
                          sty.paymentReminderSelect
                        )}
                        onChange={(...eventArgs) => {
                          p.generateStateOnChangeProp($state, [
                            "paymentReminderSelect",
                            "value"
                          ])(eventArgs[0]);
                        }}
                        placeholder={"Select"}
                        value={p.generateStateValueProp($state, [
                          "paymentReminderSelect",
                          "value"
                        ])}
                      />
                    </div>
                    <div
                      data-plasmic-name={"paymentReminderStack2"}
                      data-plasmic-override={overrides.paymentReminderStack2}
                      className={classNames(
                        projectcss.all,
                        sty.paymentReminderStack2
                      )}
                    >
                      <div
                        data-plasmic-name={"title29"}
                        data-plasmic-override={overrides.title29}
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.title29
                        )}
                      >
                        {"(after the date each payment request is sent on)"}
                      </div>
                    </div>
                  </p.Stack>
                </div>
              </div>
              <div
                data-plasmic-name={"errorText"}
                data-plasmic-override={overrides.errorText}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.errorText
                )}
              >
                {"Please enter all of the required fields"}
              </div>
              <div
                data-plasmic-name={"sendButton"}
                data-plasmic-override={overrides.sendButton}
                className={classNames(projectcss.all, sty.sendButton)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__csTA
                  )}
                >
                  {hasVariant(globalVariants, "screen", "medium")
                    ? "Review and Send"
                    : "Review and Send"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "sidebar",
    "sheet2",
    "figmaPaste",
    "title4",
    "title3",
    "selectedClient",
    "emailSelected",
    "deleteSelection",
    "searchRectangle",
    "menuSelectStack",
    "title2",
    "rectangle9",
    "contractTitleInput",
    "title10",
    "moreMilestonesStack",
    "milestoneEntry",
    "addMilestoneButton",
    "title11",
    "title12",
    "title17",
    "uploadButton",
    "title5",
    "title19",
    "rectangle26",
    "contractDescription",
    "advancedOptionsInstance",
    "advancedOptionsStack",
    "title26",
    "achSwitch",
    "cardSwitch",
    "cardSurchargeSwitch",
    "title27",
    "paymentReminderSwitch",
    "paymentReminderStack",
    "reminderNumber",
    "paymentReminderSelect",
    "paymentReminderStack2",
    "title29",
    "errorText",
    "sendButton"
  ],

  sidebar: ["sidebar"],
  sheet2: [
    "sheet2",
    "figmaPaste",
    "title4",
    "title3",
    "selectedClient",
    "emailSelected",
    "deleteSelection",
    "searchRectangle",
    "menuSelectStack",
    "title2",
    "rectangle9",
    "contractTitleInput"
  ],

  figmaPaste: [
    "figmaPaste",
    "title4",
    "title3",
    "selectedClient",
    "emailSelected",
    "deleteSelection",
    "searchRectangle",
    "menuSelectStack",
    "title2",
    "rectangle9",
    "contractTitleInput"
  ],

  title4: ["title4"],
  title3: ["title3"],
  selectedClient: ["selectedClient", "emailSelected", "deleteSelection"],
  emailSelected: ["emailSelected"],
  deleteSelection: ["deleteSelection"],
  searchRectangle: ["searchRectangle"],
  menuSelectStack: ["menuSelectStack"],
  title2: ["title2"],
  rectangle9: ["rectangle9", "contractTitleInput"],
  contractTitleInput: ["contractTitleInput"],
  title10: ["title10"],
  moreMilestonesStack: ["moreMilestonesStack", "milestoneEntry"],
  milestoneEntry: ["milestoneEntry"],
  addMilestoneButton: ["addMilestoneButton"],
  title11: ["title11"],
  title12: ["title12"],
  title17: ["title17"],
  uploadButton: ["uploadButton"],
  title5: ["title5"],
  title19: ["title19"],
  rectangle26: ["rectangle26", "contractDescription"],
  contractDescription: ["contractDescription"],
  advancedOptionsInstance: ["advancedOptionsInstance"],
  advancedOptionsStack: [
    "advancedOptionsStack",
    "title26",
    "achSwitch",
    "cardSwitch",
    "cardSurchargeSwitch",
    "title27",
    "paymentReminderSwitch",
    "paymentReminderStack",
    "reminderNumber",
    "paymentReminderSelect",
    "paymentReminderStack2",
    "title29"
  ],

  title26: ["title26"],
  achSwitch: ["achSwitch"],
  cardSwitch: ["cardSwitch"],
  cardSurchargeSwitch: ["cardSurchargeSwitch"],
  title27: ["title27"],
  paymentReminderSwitch: ["paymentReminderSwitch"],
  paymentReminderStack: [
    "paymentReminderStack",
    "reminderNumber",
    "paymentReminderSelect"
  ],

  reminderNumber: ["reminderNumber"],
  paymentReminderSelect: ["paymentReminderSelect"],
  paymentReminderStack2: ["paymentReminderStack2", "title29"],
  title29: ["title29"],
  errorText: ["errorText"],
  sendButton: ["sendButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicEscrowSubmission__ArgProps,
          internalVariantPropNames: PlasmicEscrowSubmission__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicEscrowSubmission__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicEscrowSubmission";
  } else {
    func.displayName = `PlasmicEscrowSubmission.${nodeName}`;
  }
  return func;
}

export const PlasmicEscrowSubmission = Object.assign(
  // Top-level PlasmicEscrowSubmission renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    sidebar: makeNodeComponent("sidebar"),
    sheet2: makeNodeComponent("sheet2"),
    figmaPaste: makeNodeComponent("figmaPaste"),
    title4: makeNodeComponent("title4"),
    title3: makeNodeComponent("title3"),
    selectedClient: makeNodeComponent("selectedClient"),
    emailSelected: makeNodeComponent("emailSelected"),
    deleteSelection: makeNodeComponent("deleteSelection"),
    searchRectangle: makeNodeComponent("searchRectangle"),
    menuSelectStack: makeNodeComponent("menuSelectStack"),
    title2: makeNodeComponent("title2"),
    rectangle9: makeNodeComponent("rectangle9"),
    contractTitleInput: makeNodeComponent("contractTitleInput"),
    title10: makeNodeComponent("title10"),
    moreMilestonesStack: makeNodeComponent("moreMilestonesStack"),
    milestoneEntry: makeNodeComponent("milestoneEntry"),
    addMilestoneButton: makeNodeComponent("addMilestoneButton"),
    title11: makeNodeComponent("title11"),
    title12: makeNodeComponent("title12"),
    title17: makeNodeComponent("title17"),
    uploadButton: makeNodeComponent("uploadButton"),
    title5: makeNodeComponent("title5"),
    title19: makeNodeComponent("title19"),
    rectangle26: makeNodeComponent("rectangle26"),
    contractDescription: makeNodeComponent("contractDescription"),
    advancedOptionsInstance: makeNodeComponent("advancedOptionsInstance"),
    advancedOptionsStack: makeNodeComponent("advancedOptionsStack"),
    title26: makeNodeComponent("title26"),
    achSwitch: makeNodeComponent("achSwitch"),
    cardSwitch: makeNodeComponent("cardSwitch"),
    cardSurchargeSwitch: makeNodeComponent("cardSurchargeSwitch"),
    title27: makeNodeComponent("title27"),
    paymentReminderSwitch: makeNodeComponent("paymentReminderSwitch"),
    paymentReminderStack: makeNodeComponent("paymentReminderStack"),
    reminderNumber: makeNodeComponent("reminderNumber"),
    paymentReminderSelect: makeNodeComponent("paymentReminderSelect"),
    paymentReminderStack2: makeNodeComponent("paymentReminderStack2"),
    title29: makeNodeComponent("title29"),
    errorText: makeNodeComponent("errorText"),
    sendButton: makeNodeComponent("sendButton"),
    // Metadata about props expected for PlasmicEscrowSubmission
    internalVariantProps: PlasmicEscrowSubmission__VariantProps,
    internalArgProps: PlasmicEscrowSubmission__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicEscrowSubmission;
/* prettier-ignore-end */
